import React, { useContext } from 'react'
import { useStore } from '../../store'
import { getPropertyName } from '../../helpers/property'
import Disclaimer from '../Sidebar/components/Disclaimer'
import { AppConfigContext } from '../../context/AppConfig'
import logo from './icons/logo.png'
// Logo
import { ReactComponent as SparxLogo } from './icons/sparx-logo-footer.svg'
import PoweredBy from '../PoweredBy'
import VariantWrapper from '../VariantWrapper'
import { variants } from '../../constants/variant'
function Footer({ className = '', disclaimer = false }) {
  const { data } = useStore()
  const { isBrodskyApp, isSFApp } = useContext(AppConfigContext)

  const background = isBrodskyApp ? 'bg-[#7E9CCC]' : 'bg-[#242528]'

  return (
    <div
      id="footer"
      className={`h-[30px] relative z-[90] ${background}  flex items-center px-[24px] text-[14px] text-white font-normal ${className}`}
    >
      <VariantWrapper show={variants.of}>
        <div className="w-full text-[14px] font-normal relative z-[10] flex items-center">
          Inspired Workspace
          <span className="mx-2">·</span>
          <PoweredBy />
        </div>
      </VariantWrapper>
      <VariantWrapper hide={variants.of}>
        <div className="w-full text-[16px] font-normal relative z-[10]">
          {(!isBrodskyApp && !isSFApp) && <>{getPropertyName(data?.property?.property_name)}</>}
        </div>
      </VariantWrapper>
      {disclaimer && (
        <div className="absolute left-0 w-full justify-center items-center z-1 hidden lg:flex">
          <Disclaimer btnClassName="text-white" />
        </div>
      )}
      <VariantWrapper hide={variants.of}>
        <PoweredBy />
      </VariantWrapper>
      {(!isBrodskyApp && !isSFApp) && (
        <div className="shrink-0 ml-[10px] relative z-[10]">© All Rights Reserved, SparX Inc. {new Date().getFullYear()}</div>
      )}
    </div>
  )
}

export default Footer
